









































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Mutation, Action } from 'vuex-class'
import { openShareScene } from '@bilibili/fe-quick-share'
import { linkJump } from '@bilibili/utils-leona'
// import { debounce } from 'throttle-debounce'
import logger from '@plat-components/utils2/_esm5/logger'
import Music from '@/components/music.vue'
import Timeline from '@/components/timeLine.vue'
import RightNav from '@/components/rightNav.vue'
import ShareDialog from '@/components/shareDialog.vue'
import WorkTip from '@/components/workTip.vue'
import PagContainer from '@/components/pagContainer.vue'
import Highlight from '@/components/highlight.vue'
import AnimatedSprite from '@/components/AnimatedSprite.vue'
import Decorate from '@/components/decorate.vue'
import Loading from '@/components/Loading.vue'
import { activityCode, totoalStation, sceneList } from '@/utils/config'
import drawImg from '@/utils/draw'
import { loadScFn, pagePreloadFn } from '@/utils/loading'
import { $getUniqueNo } from '@/api'
import { workInfoMap, highlightList } from '@/utils/config'
import { savePictureToMobAlbum } from '@/utils/helper'
let homePage = '//i0.hdslb.com/bfs/ogv/activity/film-history/home.pag'

@Component({
  components: {
    Music,
    Timeline,
    RightNav,
    ShareDialog,
    WorkTip,
    PagContainer,
    Highlight,
    AnimatedSprite,
    Decorate,
    Loading,
  },
})
export default class Home extends Vue {
  @State('userInfo') userInfo
  @State('currPoint') currPoint
  @State('qrCodeImg') qrCodeImg
  @State('shareConfig') shareConfig
  @State('audioLoaded') audioLoaded
  @Mutation('setCanAutoPlay') setCanAutoPlay
  @Mutation('setCurrPoint') setCurrPoint
  @Action('actionPre') actionPre
  curInfo: any = sceneList[0]
  showList: any = []
  // nextInfo = sceneList[1]
  isLock = false // 锁滑动
  timer: any = null
  bgName = 'bg'
  shareVisible = false
  changeWork = true
  isHighlight = false
  highlightInfo = {}
  homePage = homePage
  canPlay = false
  isProgress = false
  userRank = ''
  loadingProgress = 0
  // showFinal = false
  frontName = ''
  // sourceLoading = true
  isloading = true

  // 当前作品
  get currWorkInfo() {
    return workInfoMap[`step${this.currPoint}`] || workInfoMap[`step1`]
  }
  // 下一个作品
  get nextWorkInfo() {
    return workInfoMap[`step${this.currPoint}`] || workInfoMap[`step1`]
  }
  get showFinal() {
    return this.currPoint === totoalStation
  }

  get bgColor() {
    let inx = this.currPoint - 1 >= 0 ? this.currPoint - 1 : 0
    this.curInfo = sceneList[inx]
    const { bgColor = '#000' } = this.curInfo
    return { backgroundColor: bgColor }
  }

  get transLateStyle() {
    let top = this.showFinal ? 0 : '-0.8rem'
    return { top }
  }

  @Watch('currPoint')
  watchCurrPointChange(newVal) {
    // 预加载资源val前后2个站点的资源
    pagePreloadFn(newVal)
    // 判断是否为站点
    let highlightInfo = highlightList.filter((item) => item.station === newVal)
    if (highlightInfo?.length) {
      this.isHighlight = true
      this.highlightInfo = highlightInfo[0]
    } else {
      this.isHighlight = false
    }
  }

  mounted() {
    loadScFn(
      () => {
        console.log('loaded')
        this.isloading = false
        logger('homepage_show', {})
      },
      (p) => {
        this.loadingProgress = p
      },
      () => {
        this.isloading = false
        console.log('error==>')
      }
    )
  }

  handleClickStation(val) {
    if (!this.audioLoaded) {
      Vue.prototype.$toast.info('资源加载中，请稍后操作～')
      return
    }
    let offset = val - this.currPoint
    this.changePage(offset)
  }

  handleReady() {
    this.canPlay = true
  }

  handlePlayMusic() {
    this.isProgress = true
    this.$nextTick(() => {
      // tips: 代表用户点击了
      this.setCanAutoPlay(true)
      let musicRef: any = this.$refs['musicRef']
      musicRef && musicRef.play()
      // 首页point+1
      if (this.currPoint === 0) {
        this.setCurrPoint(this.currPoint + 1)
      }
      this.showList = [
        Object.assign({}, sceneList[0], {
          show: false,
          page: 0,
        }),
      ]

      this.handleTraceStation()
    })
  }

  navToRule() {
    const link =
      'https://www.bilibili.com/blackboard/topic/activity-9g0FGAQR2H.html'
    linkJump({
      link,
    })
  }
  // debounceSD = debounce(800, true, this.handleSwipeDown)
  // 处理下滑上划
  handleSwipeDown(e: any) {
    if (!this.audioLoaded) {
      Vue.prototype.$toast.info('资源加载中，请稍后操作～')
      return
    }
    const { type } = e
    let isNextPage = type === 'swipeup' || type === 'pointerup'
    let isPrevPage = type === 'swipedown' || type === 'pointerdown'
    let offset = 0
    if (isNextPage) {
      offset = 1
    }
    if (isPrevPage) {
      offset = -1
    }
    this.changePage(offset)
  }

  changePage(offset) {
    if (this.isLock) return
    //最小判断
    if (this.currPoint === 1 && offset < 0) return
    //最大判断
    if (this.currPoint === totoalStation && offset > 0) return
    // ui下面提示
    this.changeWork = !this.changeWork
    // this.currPoint += offset
    this.setCurrPoint(this.currPoint + offset)
    //这里需要做高光时刻的判断
    this.curInfo = sceneList[this.currPoint - 1]
    const { isHighlight, frontAni } = this.curInfo

    this.bgName = isHighlight ? 'highLight' : 'bg'
    this.frontName = frontAni || 'shake'
    //第一次
    const curIndex = this.showList.length < 2 ? 0 : 1
    const info = this.showList[curIndex]
    const obj = JSON.parse(JSON.stringify(info))
    obj.show = true
    this.showList = [
      obj,
      Object.assign({}, this.curInfo, {
        page: this.currPoint,
        show: false,
      }),
    ]

    // track
    this.handleTraceStation()

    this.isLock = true
    this.timer = setTimeout(() => {
      this.isLock = false
      clearTimeout(this.timer)
    }, 600)
  }

  handleTraceStation() {
    logger('stationpage_show', {
      periods: workInfoMap[`step${this.currPoint}`].ssid,
    })
  }

  // 去分享
  handleShare() {
    this.actionPre().then(async () => {
      await this.handleUserRank()
      this.shareVisible = true
      this.handleShareImg()
    })
  }

  // 生成分享图片
  handleShareImg() {
    this.$nextTick(async () => {
      Vue.prototype.$toast.loading('图片生成中，请稍等～')
      try {
        let { face, uname } = this.userInfo
        let res = await drawImg({
          poster: this.currWorkInfo.sharePoster,
          avatar: face,
          userName: uname,
          userRank: this.userRank,
          qrImg: this.qrCodeImg,
        })
        let shareImg = res && res[0].replace('http', 'https')
        shareImg =
          process.env.NODE_ENV === 'pre'
            ? shareImg.replace('https://', 'https://pre-')
            : shareImg
        console.log('%c 分享的图片地址 ------> ', 'color:#0f0;', shareImg)
        Vue.prototype.$toast.stop()
        let photoRes: any = await savePictureToMobAlbum(shareImg)
        console.log('%c photoRes ------> ', 'color:#0f0;', photoRes)
        const { code } = photoRes
        if (code == 0 || code == -5) {
          Vue.prototype.$toast.info('图片已保存至相册')
        } else {
          Vue.prototype.$toast.info('图片保存到相册失败，请稍后再试～')
        }
        this.sharePage(shareImg)
      } catch (error) {
        console.log('%c error ------> ', 'color:#0f0;', error)
        Vue.prototype.$toast.stop()
        Vue.prototype.$toast.info('图片生成失败，请稍后再试～')
      }
    })
  }

  // 分享面板
  async sharePage(val: string) {
    let shareImgs = val
    const { title, description, editContent } = this.shareConfig || {}
    const { origin, pathname } = location || {}
    console.log('%c location ------> ', 'color:#0f0;', location)
    const mainUrl = `${origin}${pathname}?navhide=1`
    console.log('%c mainUrl ------> ', 'color:#0f0;', mainUrl)
    openShareScene({
      business: 'OGV',
      pageId: 'film-history',
      shareScene: 'film-history',
      share2Config: {
        share_id: '',
        share_origin: '',
        oid: mainUrl, // 分享对象id, 配合share_id使用, 对于h5, 传递的是url
        sid: '', // 辅助id, 当oid无法定位的时候, 使用oid+sid来关联
      },
      shareInfo: {
        DEFAULT: {
          type: 'image',
          title,
          avatar: this.userInfo.face,
          url: mainUrl,
          desc: description,
          imageUrl: shareImgs || '',
        },
        BILI_DYNAMIC: {
          description, // read 图片时无作用
          editContent,
          // newTopicId: 33143,
          pictureList: [
            {
              width: 750,
              height: 1334,
              size: 2000,
              src: shareImgs || '',
            },
          ],
        },
      },
      // onClick: async (info: any) => {},
      onSuccess: async () => {
        // closeShareScene && closeShareScene()
      },
    })
  }

  async handleUserRank() {
    let res: any = await $getUniqueNo({
      activityCode,
    })
    const { number = 0 } = res
    this.userRank = `${number}位`
  }
}
